var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPopular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 12.5,
    fill: "#D6AB5A",
    stroke: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_695_1488)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7655 10.019L19.5739 5.84829L19.5739 5.84825C19.5086 5.62044 19.3556 5.42786 19.1484 5.31278C18.9412 5.19767 18.6969 5.16951 18.4689 5.23439L14.2982 6.42601V6.42606C14.0702 6.49114 13.8775 6.6441 13.7623 6.85134C13.6471 7.05858 13.619 7.30306 13.6841 7.53106C13.7493 7.75901 13.9023 7.95177 14.1096 8.06684C14.3168 8.18196 14.5614 8.21003 14.7893 8.14486L16.3979 7.68523L13.3795 13.0751L12.1094 11.8053H12.1094C11.8534 11.5491 11.4947 11.4233 11.1347 11.4634C10.7748 11.5036 10.4526 11.7053 10.2593 12.0116L6.68438 17.6717C6.45708 18.0317 6.43906 18.4856 6.63713 18.8624C6.83515 19.2392 7.21924 19.4818 7.6446 19.4986C8.06997 19.5155 8.47203 19.3042 8.69932 18.9443L11.4783 14.5446L12.8075 15.8736C13.0714 16.1375 13.4437 16.2625 13.8134 16.2113C14.1831 16.1602 14.5075 15.9388 14.6899 15.6132L18.5403 8.73743L19.0467 10.51H19.0468C19.1345 10.8171 19.3793 11.054 19.6891 11.1315C19.9989 11.2091 20.3265 11.1154 20.5485 10.886C20.7706 10.6565 20.8533 10.326 20.7656 10.0189L20.7655 10.019Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_695_1488"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.3,
    height: 14.3,
    fill: "white",
    transform: "translate(6.5 5.19995)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopular);
export default __webpack_public_path__ + "static/media/popular.ef77362b02cef936e4c71db7e8695c57.svg";
export { ForwardRef as ReactComponent };